export const MENU_ITEM = {
    full_width_full_height: 'mod3',
    full_width_half_height: 'mod7',
    half_width_full_height: 'mod6',
    half_width_half_height: 'mod9',
    full_width_min_height: 'mod10',
    half_width_full_height_booztlet: 'mod11',
    full_width_full_height_booztlet: 'mod12',
    full_width_half_height_white: 'mod8'
};

export const VIEW_TITLES = {
    createAccountView: 'create_account',
    forgotPasswordView: 'forgot_password',
    loginView: 'login'
};
